import { useEffect, useMemo, useState } from "react";
import { openNewWindow, shareURL } from "../../../../../utils/common";
import {
  PremiumPubMenuWrapper,
  PremiumPubMenuBackWrapper,
  PremiumPubFloatingWrapper,
  PremiumPubFloatingItem,
  PremiumPubMenuItem,
} from "./style";
import { usePubContext } from "../../hooks/pub-context";
import { enqueueSnackbar } from "notistack";
import { navigationTargetState } from "../../../../../recoil/store";
import { useSetRecoilState } from "recoil";
import { PremiumPubPage } from "../../hooks/use-pub-tab";
import useQuickButtons from "../../../../../hooks/useQuickButtons";

const PremiumPubFloatingMenu = () => {
  const { data, setPubPage, isPubPage } = usePubContext();
  const { openPhoneCall } = useQuickButtons();
  const [isOpen, setIsOpen] = useState(false);
  const [count, setCount] = useState(4);
  const setNavigationTarget = useSetRecoilState(navigationTargetState);

  useEffect(() => {
    const count = data?.openChatUrl ? 5 : 4;
    setCount(count);
  }, [data]);

  const handleOpenCall = () => {
    if (!data) return;
    if (data.cafeName && data.vcn) {
      openPhoneCall(data.cafeName, data.vcn);
    } else {
      enqueueSnackbar("전화번호가 없습니다.", { variant: "error" });
    }
  };

  const floatingItems = useMemo(() => {
    const base = [
      { name: "전화", src: "Phone-vip", onClick: handleOpenCall },
      {
        name: "공유",
        src: "Share-vip",
        onClick: () => shareURL(window.location.href),
      },
      {
        name: "길안내",
        src: "Navigation-vip",
        onClick: () => data && setNavigationTarget(data),
      },
      {
        name: "주변맛집",
        src: "Restaurant-vip",
        onClick: () => {
          setPubPage(PremiumPubPage.RESTAURANT);
          setIsOpen(false);
        },
      },
    ];

    if (data?.openChatUrl) {
      base.push({
        name: "오픈채팅",
        src: "Btn/Kakao-vip",
        onClick: () => data?.openChatUrl && openNewWindow(data.openChatUrl),
      });
    }

    return base;
  }, [data]);

  const menuItems = [
    { name: "상세정보", src: "detail", tab: PremiumPubPage.INFO },
    { name: "위치", src: "location", tab: PremiumPubPage.LOCATION },
    {
      name: "",
      src: `Btn/store_float_${isOpen ? "close" : "open"}`,
      tab: null,
    },
    { name: "이벤트", src: "event", tab: PremiumPubPage.EVENT },
    { name: "리뷰", src: "review", tab: PremiumPubPage.REVIEW },
  ];

  return (
    <PremiumPubMenuWrapper>
      {isOpen && (
        <PremiumPubMenuBackWrapper
          onTouchMove={(e) => e.preventDefault()}
          onClick={() => setIsOpen(false)}
        />
      )}
      {menuItems.map((item, index) => (
        <PremiumPubMenuItem
          key={index}
          isSelected={(item.tab && isPubPage(item.tab)) || false}
          isOpen={item.tab === null}
          onClick={() => (item.tab ? setPubPage(item.tab) : setIsOpen(!isOpen))}
        >
          <img
            src={`/image-web/store/${item.src}${
              item.tab && isPubPage(item.tab) ? "-select" : ""
            }.svg`}
            alt={item.name}
          />
          <div className="name">{item.name}</div>
        </PremiumPubMenuItem>
      ))}

      <PremiumPubFloatingWrapper isOpen={isOpen}>
        {floatingItems.map((item, index) => (
          <PremiumPubFloatingItem
            onClick={item.onClick}
            count={count}
            key={index}
          >
            <img src={`/image-web/store/${item.src}.svg`} alt={item.name} />
            <span>{item.name}</span>
          </PremiumPubFloatingItem>
        ))}
      </PremiumPubFloatingWrapper>
    </PremiumPubMenuWrapper>
  );
};

export default PremiumPubFloatingMenu;
